import { render } from "./emissionSourceNew.vue?vue&type=template&id=d51148d6&scoped=true"
import script from "./emissionSourceNew.vue?vue&type=script&lang=js"
export * from "./emissionSourceNew.vue?vue&type=script&lang=js"

import "./emissionSourceNew.vue?vue&type=style&index=0&id=d51148d6&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d51148d6"]])

export default __exports__